import NameValueTableRow from './NameValueTableRow'
import { NameValueDatum } from '../../types/mutual-fund-detail.types'

type NameValueTablePropTypes = {
  data: NameValueDatum[]
  gap: number
  nameClassName?: string
  valueClassName?: string
  nameValueRowClassName?: string
  nameValueTableClassName?: string
  groupForAccessibility?: boolean
}

export default function NameValueTable({
  data,
  gap,
  nameClassName,
  valueClassName,
  nameValueRowClassName,
  nameValueTableClassName,
  groupForAccessibility = false
}: NameValueTablePropTypes) {
  return (
    <div className={`flex flex-col text-[14px] ${nameValueTableClassName ?? ''}`} style={{ gap: `${gap}px` }}>
      {data?.map((datum, idx) => {
        return (
          <NameValueTableRow
            key={`${idx.toString()}-${datum?.name}-${datum?.value}`}
            name={datum?.name}
            value={datum?.value}
            nameClassName={datum?.nameClassName ?? nameClassName}
            valueClassName={datum?.valueClassName ?? valueClassName}
            nameValueRowClassName={nameValueRowClassName}
            groupForAccessibility={groupForAccessibility}
            nameContent={datum?.nameContent}
            valueContent={datum?.valueContent}
            accessibilityLabel={datum?.accessibilityLabel}
          />
        )
      })}
    </div>
  )
}
